// extracted by mini-css-extract-plugin
export default {"container":"icon-header_container__khjOT","icon":"icon-header_icon__EiYfh","text":"icon-header_text__tpmgO"};